export const textEn =
  {
    tit:"Advantages",
    sub:"OTM Software will help you achieve operational consistency in your trading this way:",
    tit1:"Multiple confirmations",
    p1:"Increase the consistency of your trades by using the confirmation of each indicator. With this data, you will never be distrustful or blind in the market again.n",
    tit2:"Easy to read",
    p2:"Look at the interaction between buyers and sellers in a simplified way. The indicators will allow you to focus only on the most relevant movements and volumes.",
    tit3:"Objective positions",
    p3:"Organize the requirements of your setups in an objective and consistent manner. You can use our high probability trading guide. There is no need to reinvent the wheel.",

};


export const textEs =
  {
    tit:"VENTAJAS",
    sub:"OTM Software le ayudará a obtener consistencia operativa en su trading de esta manera:",
    tit1:"Múltiples confirmaciones",
    p1:"Aumente la consistencia de sus operaciones usando la confirmación de cada uno de los indicadores. Teniendo estos datos nunca más tendrá desconfianza ni estará a ciegas en el mercado. ",
    tit2:"Fácil lectura",
    p2:"Observe la interaccion entre los compradores y vendedores de forma simplificada. Los indicadores le permitiran enfocarse unicamente en los movimientos y volumenes mas importantes.",
    tit3:"Entradas objetivas",
    p3:"Organice los requisitos de sus operaciones de forma objetiva y consistente. Puede usar nuestra guía de entradas de alta probabilidad, no es necesario reinventar la rueda.",


};
